import moment from 'moment';

export default (intervalMinutes = 60) => {
    let today = moment().startOf('day');

    let endOfToday = today.clone().add(1, 'days').startOf('day');

    let dates = [];

    while (today.isBefore(endOfToday)) {
        appendDate(dates, today);
        today = today.add(intervalMinutes, 'minutes');
    }

    return dates;
};

function appendDate (dateList, date) {
    dateList.push({
        'text': date.format('hh:mm A'),
        'value': date.format('HH:mm')
    });
}
